import { Game } from "./game"

interface Character {
  id: number
  variant?: number
  miiWeightClass?: number
  name: string
  icon: string
}

export const characterMap: Record<Game, Character[]> = {
  [Game.MK8]: [
    { id: 0, name: "Mario", icon: "mario" },
    { id: 1, name: "Luigi", icon: "luigi" },
    { id: 2, name: "Peach", icon: "peach" },
    { id: 3, name: "Daisy", icon: "daisy" },
    { id: 4, name: "Yoshi", icon: "yoshi" },
    { id: 4, variant: 1, name: "Red Yoshi", icon: "red_yoshi" },
    { id: 4, variant: 2, name: "Blue Yoshi", icon: "blue_yoshi" },
    { id: 4, variant: 3, name: "Light-blue Yoshi", icon: "light_blue_yoshi" },
    { id: 4, variant: 4, name: "Yellow Yoshi", icon: "yellow_yoshi" },
    { id: 4, variant: 5, name: "Pink Yoshi", icon: "pink_yoshi" },
    { id: 4, variant: 6, name: "Black Yoshi", icon: "black_yoshi" },
    { id: 4, variant: 7, name: "White Yoshi", icon: "white_yoshi" },
    { id: 4, variant: 8, name: "Orange Yoshi", icon: "orange_yoshi" },
    { id: 5, name: "Toad", icon: "toad" },
    { id: 6, name: "Toadette", icon: "toadette" },
    { id: 7, name: "Koopa Troopa", icon: "koopa_troopa" },
    { id: 8, name: "Bowser", icon: "bowser" },
    { id: 9, name: "Donkey Kong", icon: "donkey_kong" },
    { id: 10, name: "Wario", icon: "wario" },
    { id: 11, name: "Waluigi", icon: "waluigi" },
    { id: 12, name: "Rosalina", icon: "rosalina" },
    { id: 13, name: "Metal Mario", icon: "metal_mario" },
    { id: 14, name: "Pink Gold Peach", icon: "pink_gold_peach" },
    { id: 15, name: "Lakitu", icon: "lakitu" },
    { id: 16, name: "Shy Guy", icon: "shy_guy" },
    { id: 16, variant: 1, name: "Green Shy Guy", icon: "green_shy_guy" },
    { id: 16, variant: 2, name: "Blue Shy Guy", icon: "blue_shy_guy" },
    { id: 16, variant: 3, name: "Light-blue Shy Guy", icon: "light_blue_shy_guy" },
    { id: 16, variant: 4, name: "Yellow Shy Guy", icon: "yellow_shy_guy" },
    { id: 16, variant: 5, name: "Pink Shy Guy", icon: "pink_shy_guy" },
    { id: 16, variant: 6, name: "Black Shy Guy", icon: "black_shy_guy" },
    { id: 16, variant: 7, name: "White Shy Guy", icon: "white_shy_guy" },
    { id: 16, variant: 8, name: "Orange Shy Guy", icon: "orange_shy_guy" },
    { id: 17, name: "Baby Mario", icon: "baby_mario" },
    { id: 18, name: "Baby Luigi", icon: "baby_luigi" },
    { id: 19, name: "Baby Peach", icon: "baby_peach" },
    { id: 20, name: "Baby Daisy", icon: "baby_daisy" },
    { id: 21, name: "Baby Rosalina", icon: "baby_rosalina" },
    { id: 22, name: "Larry", icon: "larry" },
    { id: 23, name: "Lemmy", icon: "lemmy" },
    { id: 24, name: "Wendy", icon: "wendy" },
    { id: 25, name: "Ludwig", icon: "ludwig" },
    { id: 26, name: "Iggy", icon: "iggy" },
    { id: 27, name: "Roy", icon: "roy" },
    { id: 28, name: "Morton", icon: "morton" },
    { id: 29, miiWeightClass: 0, name: "Light Mii", icon: "mii" },
    { id: 29, miiWeightClass: 1, name: "Medium Mii", icon: "mii" },
    { id: 29, miiWeightClass: 2, name: "Heavy Mii", icon: "mii" },
    { id: 30, name: "Tanooki Mario", icon: "tanooki_mario" },
    { id: 31, name: "Link", icon: "link" },
    { id: 32, name: "Male Villager", icon: "male_villager" },
    { id: 33, name: "Isabelle", icon: "isabelle" },
    { id: 34, name: "Cat Peach", icon: "cat_peach" },
    { id: 35, name: "Dry Bowser", icon: "dry_bowser" },
    { id: 36, name: "Female Villager", icon: "female_villager" },
  ],
  [Game.MK8DX]: [
    { id: 0, name: "Mario", icon: "mario" },
    { id: 1, name: "Luigi", icon: "luigi" },
    { id: 2, name: "Peach", icon: "peach" },
    { id: 3, name: "Daisy", icon: "daisy" },
    { id: 4, name: "Yoshi", icon: "yoshi" },
    { id: 4, variant: 1, name: "Red Yoshi", icon: "red_yoshi" },
    { id: 4, variant: 2, name: "Blue Yoshi", icon: "blue_yoshi" },
    { id: 4, variant: 3, name: "Light-blue Yoshi", icon: "light_blue_yoshi" },
    { id: 4, variant: 4, name: "Yellow Yoshi", icon: "yellow_yoshi" },
    { id: 4, variant: 5, name: "Pink Yoshi", icon: "pink_yoshi" },
    { id: 4, variant: 6, name: "Black Yoshi", icon: "black_yoshi" },
    { id: 4, variant: 7, name: "White Yoshi", icon: "white_yoshi" },
    { id: 4, variant: 8, name: "Orange Yoshi", icon: "orange_yoshi" },
    { id: 5, name: "Toad", icon: "toad" },
    { id: 6, name: "Toadette", icon: "toadette" },
    { id: 7, name: "Koopa Troopa", icon: "koopa_troopa" },
    { id: 8, name: "Bowser", icon: "bowser" },
    { id: 9, name: "Donkey Kong", icon: "donkey_kong" },
    { id: 10, name: "Wario", icon: "wario" },
    { id: 11, name: "Waluigi", icon: "waluigi" },
    { id: 12, name: "Rosalina", icon: "rosalina" },
    { id: 13, name: "Metal Mario", icon: "metal_mario" },
    { id: 14, name: "Pink Gold Peach", icon: "pink_gold_peach" },
    { id: 15, name: "Lakitu", icon: "lakitu" },
    { id: 16, name: "Shy Guy", icon: "shy_guy" },
    { id: 16, variant: 1, name: "Green Shy Guy", icon: "green_shy_guy" },
    { id: 16, variant: 2, name: "Blue Shy Guy", icon: "blue_shy_guy" },
    { id: 16, variant: 3, name: "Light-blue Shy Guy", icon: "light_blue_shy_guy" },
    { id: 16, variant: 4, name: "Yellow Shy Guy", icon: "yellow_shy_guy" },
    { id: 16, variant: 5, name: "Pink Shy Guy", icon: "pink_shy_guy" },
    { id: 16, variant: 6, name: "Black Shy Guy", icon: "black_shy_guy" },
    { id: 16, variant: 7, name: "White Shy Guy", icon: "white_shy_guy" },
    { id: 16, variant: 8, name: "Orange Shy Guy", icon: "orange_shy_guy" },
    { id: 17, name: "Baby Mario", icon: "baby_mario" },
    { id: 18, name: "Baby Luigi", icon: "baby_luigi" },
    { id: 19, name: "Baby Peach", icon: "baby_peach" },
    { id: 20, name: "Baby Daisy", icon: "baby_daisy" },
    { id: 21, name: "Baby Rosalina", icon: "baby_rosalina" },
    { id: 22, name: "Larry", icon: "larry" },
    { id: 23, name: "Lemmy", icon: "lemmy" },
    { id: 24, name: "Wendy", icon: "wendy" },
    { id: 25, name: "Ludwig", icon: "ludwig" },
    { id: 26, name: "Iggy", icon: "iggy" },
    { id: 27, name: "Roy", icon: "roy" },
    { id: 28, name: "Morton", icon: "morton" },
    { id: 29, miiWeightClass: 0, name: "Light Mii", icon: "mii" },
    { id: 29, miiWeightClass: 1, name: "Medium Mii", icon: "mii" },
    { id: 29, miiWeightClass: 2, name: "Heavy Mii", icon: "mii" },
    { id: 30, name: "Tanooki Mario", icon: "tanooki_mario" },
    { id: 31, name: "Link", icon: "link" },
    { id: 32, name: "Male Villager", icon: "male_villager" },
    { id: 33, name: "Isabelle", icon: "isabelle" },
    { id: 34, name: "Cat Peach", icon: "cat_peach" },
    { id: 35, name: "Dry Bowser", icon: "dry_bowser" },
    { id: 36, name: "Female Villager", icon: "female_villager" },
    { id: 37, name: "Gold Mario", icon: "gold_mario" },
    { id: 38, name: "Dry Bones", icon: "dry_bones" },
    { id: 39, name: "Bowser Jr.", icon: "bowser_jr" },
    { id: 40, name: "King Boo", icon: "king_boo" },
    { id: 41, name: "Inkling Girl", icon: "inkling_girl" },
    { id: 41, variant: 1, name: "Lime Green Inkling Girl", icon: "lime_green_inkling_girl" },
    { id: 41, variant: 2, name: "Magenta Inkling Girl", icon: "magenta_inkling_girl" },
    { id: 42, name: "Inkling Boy", icon: "inkling_boy" },
    { id: 42, variant: 1, name: "Purple Inkling Boy", icon: "purple_inkling_boy" },
    { id: 42, variant: 2, name: "Teal Inkling Boy", icon: "teal_inkling_boy" },
    { id: 43, name: "Champion Link", icon: "champion_link" },
    { id: 44, name: "Birdo", icon: "birdo" },
    { id: 44, variant: 1, name: "Red Birdo", icon: "red_birdo" },
    { id: 44, variant: 2, name: "Blue Birdo", icon: "blue_birdo" },
    { id: 44, variant: 3, name: "Light-blue Birdo", icon: "light_blue_birdo" },
    { id: 44, variant: 4, name: "Yellow Birdo", icon: "yellow_birdo" },
    { id: 44, variant: 5, name: "Green Birdo", icon: "green_birdo" },
    { id: 44, variant: 6, name: "Black Birdo", icon: "black_birdo" },
    { id: 44, variant: 7, name: "White Birdo", icon: "white_birdo" },
    { id: 44, variant: 8, name: "Orange Birdo", icon: "orange_birdo" },
    { id: 45, name: "Kamek", icon: "kamek" },
    { id: 46, name: "Petey Piranha", icon: "petey_piranha" },
    { id: 47, name: "Wiggler", icon: "wiggler" },
    { id: 48, name: "Diddy Kong", icon: "diddy_kong" },
    { id: 49, name: "Funky Kong", icon: "funky_kong" },
    { id: 50, name: "Peachette", icon: "peachette" },
    { id: 51, name: "Pauline", icon: "pauline" },
    { id: 52, miiWeightClass: 0, name: "Light Mii", icon: "mii" },
    { id: 52, miiWeightClass: 1, name: "Medium Mii", icon: "mii" },
    { id: 52, miiWeightClass: 2, name: "Heavy Mii", icon: "mii" },
  ],
}